export const hasStrCodeProperty = (item: { strCode?: string } | string | undefined) => {
  if (item && typeof item === 'object' && typeof item.strCode === 'string') {
    return true;
  }

  return false;
};
